import { apiClient } from './api';

/**
 * Payment Service
 * Handles all payment-related API calls
 */
export const paymentService = {
  /**
   * Get payment history
   * @param {Object} params - Query parameters (payment_method, start_date, end_date, account_id, page, per_page)
   * @returns {Promise} Payment history list
   */
  getPaymentHistory: (params = {}) => {
    return apiClient.get('/finance/payment-history', params);
  },

  /**
   * Get payment method
   * @param {Object} params - Query parameters (account_id)
   * @returns {Promise} Payment method data
   */
  getPaymentMethod: (params = {}) => {
    return apiClient.get('/finance/payment-method', params);
  },

  /**
   * Update payment method
   * @param {Object} data - Payment method data
   * @returns {Promise} Updated payment method
   */
  updatePaymentMethod: (data) => {
    return apiClient.put('/finance/payment-method', data);
  },
};
